import api from '../apiService';
import {populateFields, clearFields, propSpinner, disableSaveButton, createDebouncedMemoRequest} from '../utils';

const debounceSearch = createDebouncedMemoRequest(api.getData, 300);
const fields = ['iban', 'bic', 'bank', 'bank_country', 'payment_city', 'payment_cap'];

const fieldMap = (data) => ({
    iban: data.iban || null,
    bic: data.bic || null,
    bank: data.bank || null,
    bank_country: data.bank_country || null,
    payment_city: data.payment_city || null,
    payment_cap: data.payment_cap || null,
    plate: data.plate || null,
    vehicle_address: data.vehicle_address || null,
});

export async function fetchExternalPersonData(externalPersonField) {
    const externalPersonId = $('select[name="' + externalPersonField + '"]').val();
    if (!externalPersonId) {
        clearFields(fields);
        return;
    }

    propSpinner(fields, true);
    disableSaveButton(true);

    const cacheKey = `${externalPersonField}-${externalPersonId}`;

    debounceSearch(cacheKey, `/api/app/backpack/fetch-external-person-data`, {
        params: {
            external_person_id: externalPersonId
        },
    }).then((data) => {
        if (data) {
            populateFields(fieldMap(data));
        }
    }).catch(() => {
        clearFields(fields);
    }).finally(() => {
        propSpinner(fields, false);
        disableSaveButton(false);
    });
}
